import { faBuildings, faAt } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { getFileIcon } from 'utils/getFileIcon'

import { InlineReferenceByType } from './useInlineReferenceType'

export const ReferenceIcon = ({ referenceWithType }: { referenceWithType: InlineReferenceByType }) => {
  if (referenceWithType.type === 'document-reference') {
    return <FontAwesomeIcon icon={faAt} />
  }
  if (referenceWithType.type === 'attachment') {
    return <FontAwesomeIcon icon={getFileIcon({ attachmentStatus: undefined, contentType: referenceWithType.attachment.contentType }).icon} />
  }
  if (referenceWithType.type === 'company-upload') {
    return <FontAwesomeIcon icon={faBuildings} />
  }
  return null
}
